import { useEffect, useRef } from "react";
import TagManager from "react-gtm-module";
import { IGlobal } from "src/types/layout";
import { initGtm } from "../utils/gtm-utils";

interface IUseGtmProps<TData> {
    global: IGlobal | null;
    data: TData | null | undefined;
}

export function useGtm<TData>({ global, data }: IUseGtmProps<TData>) {
    const isGtmInitializedRef = useRef(false);

    // Dev-Note: needs to be refactored when switching to client-side rendering
    useEffect(() => {
        if (isGtmInitializedRef.current) {
            return;
        }

        if (global && data) {
            TagManager.initialize(initGtm(global.gtmData));
            isGtmInitializedRef.current = true;
        }
    }, [data, global]);
}
